import React from 'react';
import { I18n } from 'react-redux-i18n';
import SweetAlert from 'react-bootstrap-sweetalert';

import addNotification from '../../../components/notification';

class ProductSerialForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      serials: this.buildSerials(props.quantity, props.serials),
      showExcludeSerialAlert: false,
      excludeSerialFromIndex: null,
      excludeSerialCurrentIndex: null,
    };
  }

  componentDidMount() {
    this.focusTimeout = setTimeout(() => {
      this.focusFirstAvailableSerial();
    }, 400);
  }

  componentWillUnmount() {
    if (this.focusTimeout) {
      clearTimeout(this.focusTimeout);
    }
    this.notifySerialsChange(this.state.serials);
  }

  getFirstAvailableSerialIndex = () => {
    const { serials } = this.state;
    for (let index = 0; index < serials.length; index += 1) {
      if (!(serials[index] || '').trim()) {
        return index;
      }
    }
    return 0;
  };

  focusFirstAvailableSerial = () => {
    const focusIndex = this.getFirstAvailableSerialIndex();
    const serialInput = document.getElementById(`product-serial-${focusIndex}`);
    if (serialInput) {
      serialInput.scrollIntoView({ block: 'center', inline: 'nearest' });
      serialInput.focus();
      serialInput.select();
    }
  };

  notifySerialsChange = (serials) => {
    if (this.props.onSerialsChange) {
      this.props.onSerialsChange(serials);
    }
  };

  setSerialValue = (index, value) => {
    this.setState((prevState) => {
      const serials = prevState.serials.slice();
      serials[index] = value;
      return { serials };
    }, () => {
      this.notifySerialsChange(this.state.serials);
    });
  };

  getCurrentFormDuplicateIndex = (index, serialValue) => {
    const serialKey = (serialValue || '').trim().toUpperCase();
    if (!serialKey) {
      return -1;
    }

    const { serials } = this.state;
    for (let serialIndex = 0; serialIndex < serials.length; serialIndex += 1) {
      if (serialIndex !== index) {
        const otherSerial = (serials[serialIndex] || '').trim().toUpperCase();
        if (otherSerial && otherSerial === serialKey) {
          return serialIndex;
        }
      }
    }

    return -1;
  };

  isDuplicatedInPreviousConference = (serialValue) => {
    const serialKey = (serialValue || '').trim().toUpperCase();
    if (!serialKey) {
      return false;
    }

    const existingSerials = this.props.existingSerials || [];
    for (let existingIndex = 0; existingIndex < existingSerials.length; existingIndex += 1) {
      const existingSerial = (existingSerials[existingIndex] || '').trim().toUpperCase();
      if (existingSerial && existingSerial === serialKey) {
        return true;
      }
    }

    return false;
  };

  clearSerialField = (index, callback) => {
    this.setState((prevState) => {
      const serials = prevState.serials.slice();
      serials[index] = '';
      return { serials };
    }, () => {
      this.notifySerialsChange(this.state.serials);
      if (callback) {
        callback();
      }
    });
  };

  confirmExcludeSerial = () => {
    const { excludeSerialFromIndex } = this.state;
    this.setState((prevState) => {
      const serials = prevState.serials.slice();
      serials[excludeSerialFromIndex] = '';
      return {
        serials,
        showExcludeSerialAlert: false,
        excludeSerialFromIndex: null,
        excludeSerialCurrentIndex: null,
      };
    }, () => {
      this.notifySerialsChange(this.state.serials);
      this.focusSerialInput(excludeSerialFromIndex);
    });
  };

  cancelExcludeSerial = () => {
    const { excludeSerialCurrentIndex } = this.state;
    this.setState((prevState) => {
      const serials = prevState.serials.slice();
      serials[excludeSerialCurrentIndex] = '';
      return {
        serials,
        showExcludeSerialAlert: false,
        excludeSerialFromIndex: null,
        excludeSerialCurrentIndex: null,
      };
    }, () => {
      this.notifySerialsChange(this.state.serials);
      this.focusSerialInput(excludeSerialCurrentIndex);
    });
  };

  validateSerialInput = (index, serialValue) => {
    const trimmedSerial = (serialValue || '').trim();

    if (!trimmedSerial) {
      addNotification(
        'danger',
        I18n.t('BEE37' /* Conferência */),
        I18n.t('BEE2324', { 0: I18n.t('BEE500' /* Serial */) } /* Campo (%{0}) deve ser informado */),
        'top-right',
      );
      return false;
    }

    if (this.isDuplicatedInPreviousConference(trimmedSerial)) {
      addNotification(
        'danger',
        I18n.t('BEE37' /* Conferência */),
        I18n.t('BEE262' /* O código informado já existe! */),
        'top-right',
      );
      this.clearSerialField(index, () => this.focusSerialInput(index));
      return false;
    }

    const duplicateIndex = this.getCurrentFormDuplicateIndex(index, trimmedSerial);
    if (duplicateIndex !== -1) {
      this.setState({
        showExcludeSerialAlert: true,
        excludeSerialFromIndex: duplicateIndex,
        excludeSerialCurrentIndex: index,
      });
      return false;
    }

    return true;
  };

  focusSerialInput = (index) => {
    const serialInput = document.getElementById(`product-serial-${index}`);
    if (serialInput) {
      serialInput.focus();
      serialInput.select();
    }
  };

  goToElement = (e, index) => {
    if (e.keyCode === 13 || e.keyCode === 9) {
      const currentValue = e.target.value;
      if (!this.validateSerialInput(index, currentValue)) {
        e.preventDefault();
        this.focusSerialInput(index);
        return;
      }

      if (e.keyCode === 13) {
        e.preventDefault();
        const nextInput = document.getElementById(`product-serial-${index + 1}`);
        if (nextInput) {
          nextInput.focus();
          nextInput.select();
        } else {
          this.confirmSerials();
        }
      }
    }
  };

  confirmSerials = () => {
    const { serials } = this.state;
    const trimmedSerials = serials.map((serial) => (serial || '').trim());

    for (let index = 0; index < trimmedSerials.length; index += 1) {
      if (!this.validateSerialInput(index, trimmedSerials[index])) {
        this.focusSerialInput(index);
        return;
      }
    }

    this.props.onConfirm(trimmedSerials);
  };

  getFilledSerialsCount = () => {
    const { serials } = this.state;
    let filledCount = 0;
    for (let index = 0; index < serials.length; index += 1) {
      if ((serials[index] || '').trim()) {
        filledCount += 1;
      }
    }
    return filledCount;
  };

  createInput = (
    value,
    index,
    label,
    placeholder,
    keypressFunction = undefined,
    id = null,
    disabled = false,
  ) => (
    <div className="form-group p-2 text-left">
      <label htmlFor={id || label}>{label}</label>
      <div className="input-group">
        <input
          onKeyDown={!disabled && keypressFunction && ((e) => keypressFunction(e, index))}
          id={id && id}
          type="text"
          className="form-control"
          value={value || ''}
          maxLength={40}
          onChange={(e) => this.setSerialValue(index, e.target.value)}
          placeholder={disabled ? '' : placeholder}
          required={!disabled}
          disabled={disabled}
        />
      </div>
    </div>
  );

  buildSerials(quantity, currentSerials = []) {
    const serialQuantity = parseInt(quantity, 10) || 0;
    const serials = [];
    const previousSerials = currentSerials || [];

    for (let index = 0; index < serialQuantity; index += 1) {
      serials.push(previousSerials[index] || '');
    }

    return serials;
  }

  render() {
    const { serials, showExcludeSerialAlert } = this.state;
    const existingSerials = this.props.existingSerials || [];
    const filledCount = existingSerials.length + this.getFilledSerialsCount();
    const totalCount = existingSerials.length + serials.length;

    return (
      <span>
        <div className="row" style={{ maxHeight: '360px', overflowY: 'auto' }}>
          {existingSerials.map((serial, index) => (
            <div className="col-md-6" key={`existing-${index}`}>
              {this.createInput(
                serial,
                index,
                `${I18n.t('BEE500' /* Serial */)} ${index + 1}`,
                I18n.t('BEE500' /* Serial */),
                undefined,
                `product-serial-existing-${index}`,
                true,
              )}
            </div>
          ))}
          {serials.map((serial, index) => (
            <div className="col-md-6" key={`new-${index}`}>
              {this.createInput(
                serial,
                index,
                `${I18n.t('BEE500' /* Serial */)} ${existingSerials.length + index + 1}`,
                I18n.t('BEE500' /* Serial */),
                this.goToElement,
                `product-serial-${index}`,
              )}
            </div>
          ))}
        </div>
        <div className="row">
          <div className="col text-right p-2">
            <span className="pr-2 f-s-16 f-w-600">{`${filledCount}/${totalCount}`}</span>
            <button type="button" className="btn btn-120 btn-primary" onClick={() => this.confirmSerials()}>
              {I18n.t('BEE100' /* Confirmar */)}
            </button>
          </div>
        </div>
        {showExcludeSerialAlert && (
          <SweetAlert
            warning
            showCancel
            cancelBtnText={I18n.t('BEE173' /* Não */)}
            confirmBtnText={I18n.t('BEE172' /* Sim */)}
            confirmBtnBsStyle="danger"
            cancelBtnBsStyle="default"
            title={I18n.t('BEE37' /* Conferência */)}
            onConfirm={this.confirmExcludeSerial}
            onCancel={this.cancelExcludeSerial}
          >
            {I18n.t('BEE4812' /* Serial já informado para este produto, deseja EXCLUIR? */)}
          </SweetAlert>
        )}
      </span>
    );
  }
}

export default ProductSerialForm;
